module.exports = __webpack_public_path__ + "aee3b25ed3a32f8c5f737c96dee8efcc.svg";